// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListSkeleton-moduleitem__yY28Q";
var _2 = "GretaAIChatChatListSkeleton-moduleitemSubtitle__OQLWn Skeleton-moduleSkeleton__Mlrfv";
var _3 = "GretaAIChatChatListSkeleton-moduleitemTitle__Sh4vL Skeleton-moduleSkeleton__Mlrfv";
var _4 = "GretaAIChatChatListSkeleton-moduleitems__zKH49";
var _5 = "GretaAIChatChatListSkeleton-modulesection__QyoO8";
var _6 = "GretaAIChatChatListSkeleton-modulesectionTitle__hzSIK Skeleton-moduleSkeleton__Mlrfv";
var _7 = "GretaAIChatChatListSkeleton-moduleskeleton__ihiVT";
export { _1 as "item", _2 as "itemSubtitle", _3 as "itemTitle", _4 as "items", _5 as "section", _6 as "sectionTitle", _7 as "skeleton" }
